import React from "react";
import BetterBenifitsImg from "../../../assets/EMP_whyus/BetterBenifits/betterbenifits.webp";

function BetterBenifits() {
  return (
    <section
      className="
        bg-[white]

        px-6
        sm:px-10
        lg:px-16

        py-14
        lg:py-10
      "
    >
      <div
        className="
          max-w-[1400px]
          mx-auto

          grid
          grid-cols-1
          lg:grid-cols-2

          gap-14
          lg:gap-20

          items-start
        "
      >
        {/* LEFT SIDE */}
        <div className="lg:ml-[60px]">
          <h1
            className="
              text-[#290001]

              text-[36px]
              sm:text-[58px]
              lg:text-[46px]
              lg:font-[400]
              lg:-tracking-[4px]
              font-[900]
              md:ml-3
              lg:ml-4

              leading-[0.95]

              max-w-[520px]
            "
          >
            Unlock a Better
            <br className="hidden md:block"  />
            Benefits Strategy
          </h1>

          <p
            className="
              mt-10
              md:mt-10
              lg:mt-8

              text-[#111111]

              text-[16px]
              md:text-[18px]
              lg:text-[19px]

              leading-[1.5]

              max-w-[620px]
            "
          >
            Download our exclusive white paper and discover
            why smart <br className="hidden sm:block" /> employers are choosing financial wellness
            benefits for their <br /> workforce.
          </p>

          <p
            className="
              mt-8
              lg:mt-10

              text-[14px]
              font-[900]
              lg:text-[18px]

              text-[#111111]

              leading-[1.5]
            "
          >
            The{" "}
            <span className="font-bold">
              Future of Voluntary Benefits for Hourly Workers
            </span>{" "}
            reveals:
          </p>

          {/* LIST */}
          <div
            className="
              mt-10
              lg:mt-8
               gap-4
              text-[16px]
              md:text-[18px]
              lg:text-[16px]

              space-y-2
            "
          >
            {[
              "Industry benchmarks for voluntary benefit adoption",
              "ROI calculations for On-Demand Pay programs",
              "Strategies to maximize employee engagement",
              "Predictions from HR and benefits leaders",
            ].map((item, index) => (
              <div
                key={index}
                className="
                  flex
                  items-start

                  gap-4
                  text-[12px]
                  md:text-[16px]
                  lg:text-[18px]
                "
              >
                {/* ICON */}
                <div
                  className="
                    w-7
                    h-7

                    rounded-full

                    bg-[#290001]

                    flex
                    items-center
                    justify-center

                    shrink-0

                    mt-[2px]
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    className="w-4 h-4"
                  >
                    <path
                      d="M5 13l4 4L19 7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <p
                  className="
                    text-[15px]
                    lg:text-[16px]
                    font-[600]

                    text-[#111111]

                    leading-[1.5]
                  "
                >
                  {item}
                </p>
              </div>
            ))}
          </div>

          {/* IMAGE CARD */}
          <div
            className="
              mt-16

              bg-[white]
              shadow-md
            
              rounded-[10px]

              p-6

              w-[100%]
              lg:w-[90%]
              max-w-[520px]

              relative

              overflow-hidden
            "
          >
            <img
              src={ BetterBenifitsImg}
              alt="Benefits"

              className="
                w-[800px]
                md:w-[100%]
                lg:w-[100%]

                rounded-[8px]

                object-cover
              "
            />
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
<div
  className="
    bg-white
    rounded-[10px]

    shadow-[0_0_25px_rgba(0,0,0,0.12)]

    lg:mt-[100px]

    p-6
    sm:p-8
    lg:p-6

    w-full
    lg:w-[500px]

    max-w-[550px]

    mx-auto

    px-5
    sm:px-8
    lg:px-6

  "
>
  <h1
    className="
      text-[#290001]
      lg:mt-6

      text-[32px]
      sm:text-[40px]
      lg:text-[22px]
    font-sans


      leading-[1.05]

      max-w-[620px]
    "
  >
    Download the data that
    <br className="hidden sm:block lg:hidden" />
    drives results
  </h1>

  <form
    className="
      mt-8
      lg:mt-14
      sm:mt-10

      space-y-5
      sm:space-y-6
      lg:space-y-2
    "
  >
    {/* ROW */}
    <div
      className="
        grid
        grid-cols-2
        lg:-mt-8

        gap-3
        sm:gap-5
      "
    >
      {/* FIRST NAME */}
      <div>
        <label
          className="
            block

            text-[13px]
            sm:text-[16px]
            lg:text-[14px]

            font-semibold

            text-[#111111]

            mb-2
            lg:mb-1
          "
        >
          First Name <span className="text-red-500">*</span>
        </label>

        <input
          type="text"
          className="
            w-full

            h-[44px]
            sm:h-[48px]
            lg:h-[45px]

            border
            border-[#d6d6d6]

            rounded-[4px]

            px-3
            sm:px-4

            outline-none

            focus:border-[#4b0000]
          "
        />
      </div>

      {/* LAST NAME */}
      <div>
        <label
          className="
            block

            text-[13px]
            sm:text-[16px]
            lg:text-[14px]

            font-semibold

            text-[#111111]

            mb-2
          "
        >
          Last Name <span className="text-red-500">*</span>
        </label>

        <input
          type="text"
          className="
            w-full

            h-[44px]
            sm:h-[48px]
            lg:h-[45px]

            border
            border-[#d6d6d6]

            rounded-[4px]

            px-3
            sm:px-4

            outline-none

            focus:border-[#4b0000]
          "
        />
      </div>
    </div>

    {/* EMAIL */}
    <div>
      <label
        className="
          block

          text-[13px]
          sm:text-[16px]
          lg:text-[14px]

          font-semibold

          text-[#111111]

          mb-2
        "
      >
        Work Email <span className="text-red-500">*</span>
      </label>

      <input
        type="email"
        className="
          w-full

          h-[44px]
          sm:h-[48px]
          lg:h-[45px]

          border
          border-[#d6d6d6]

          rounded-[4px]

          px-3
          sm:px-4

          outline-none

          focus:border-[#4b0000]
        "
      />
    </div>

    {/* COMPANY */}
    <div>
      <label
        className="
          block

          text-[13px]
          sm:text-[16px]
          lg:text-[14px]

          font-semibold

          text-[#111111]

          mb-2
        "
      >
        Company Name <span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        className="
          w-full

          h-[44px]
          sm:h-[48px]
          lg:h-[45px]

          border
          border-[#d6d6d6]

          rounded-[4px]

          px-3
          sm:px-4

          outline-none

          focus:border-[#4b0000]
        "
      />
    </div>

    {/* EMPLOYEES */}
    <div>
      <label
        className="
          block

          text-[13px]
          sm:text-[16px]
          lg:text-[14px]

          font-semibold

          text-[#111111]

          mb-2
        "
      >
        Number of Employees <span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        className="
          w-full

          h-[44px]
          sm:h-[48px]
          lg:h-[45px]

          border
          border-[#d6d6d6]

          rounded-[4px]

          px-3
          sm:px-4

          outline-none

          focus:border-[#4b0000]
        "
      />
    </div>

    {/* INDUSTRY */}
    <div>
      <label
        className="
          block

          text-[13px]
          sm:text-[16px]

          font-semibold

          text-[#111111]

          mb-2
        "
      >
        Industry
      </label>

      <select
        className="
          w-full

          h-[44px]
          sm:h-[48px]
          lg:h-[45px]

          border
          border-[#d6d6d6]

          rounded-[4px]

          px-3
          sm:px-4

          outline-none

          bg-white

          focus:border-[#4b0000]
        "
      >
        <option>Select...</option>
        <option>Technology</option>
        <option>Healthcare</option>
        <option>Retail</option>
      </select>
    </div>

    {/* BUTTON */}
    <button
      type="submit"
      className="
        mt-2
        lg:mt-6

        bg-[#4b0000]
        bg:hover-[#4b0100]

        text-white

        px-6
        sm:px-8

        py-3
        lg:py-2
        lg:px-4

        text-[16px]
        sm:text-[18px]

        font-semibold

        hover:opacity-90

        transition-all
        duration-300
      "
    >
      Download Now
    </button>

    {/* CAPTCHA TEXT */}
    <p
      className="
        text-[12px]
        sm:text-[13px]

        text-[#777]

        italic
      "
    >
      This site is protected by reCAPTCHA.
    </p>
  </form>
</div>
      </div>
    </section>
  );
}

export default BetterBenifits;